// extracted by mini-css-extract-plugin
export var addWidgetButton = "_n-6";
export var backButton = "_n-1";
export var legacyWidgetContainer = "_n-5";
export var pageContainer = "_n-2";
export var settingsContent = "_n-0";
export var widgetSubsectionItem = "_n-3";
export var widgetSubsectionItemContent = "_n-4";